import React, {Component, createRef, Fragment} from 'react';
import {Col, Container, Row} from 'react-bootstrap';
import {
    FileEditorEnhance,
	FileUploadOverlay
} from "../Files";
import {
	Glyphicon
} from "../GlyphIcon";
import {
	PermissionCheckerEnhance,
	StreamBankEditableCheckerEnhance
} from "../Enhancements";

import {service as ContextNodeService} from  "../../../Services/ContextNodeService";
import {service as FileUploadService} from  "../../../Services/FileUploadService";

import autobind from 'autobind-decorator';
import Dropzone from 'react-dropzone';
import {StreamBankErrorDispatchEnhance} from "../Enhancements";

export const FileBrowserEnhance = ((ComposedComponent) => {
    @PermissionCheckerEnhance
    @StreamBankEditableCheckerEnhance
    @StreamBankErrorDispatchEnhance
    @FileEditorEnhance
    class FileBrowserEnhance extends Component {
        constructor(props) {
            super(props);

            this.inputField = createRef();
            this.tableComponent = createRef();

            this.state = {
                displayUpload: false,
                uploadingFiles: false,
                contextNode: null,
                uploadProgress: [],
                lastChanged: null,
            };
        }

        @autobind
        displayDialog() {
            const { inputField } = this;

            inputField?.current?.click?.();
        }

        @autobind
        reloadData() {
            //If we're composing one of our components we should refresh it.
            // this.composedComponent?.current?.loadData?.();
            //IF we have a table component. lets update it as well.
            this.tableComponent?.current?.reloadData?.();
            this.tableComponent?.current?.changeSort?.("created");
            this.tableComponent?.current?.changeSortToDesc?.();
        }

        @autobind
        displayProgress() {
            this.setState({ displayUpload: true });
        }

        @autobind
        hideProgress() {
            this.setState({ displayUpload: false, uploadingFiles: false, uploadProgress: [] });
        }

        @autobind
        setContextId(contextNodeId) {
            const { contextNode } = this.state;

            if(contextNode == null || contextNode.contextNodeId !== contextNodeId) {
                Promise.all([
                    ContextNodeService.GetContextNode(contextNodeId)
                ]).then(([contextNode]) => {
                    this.setState({
                        contextNode: contextNode.result
                    });
                });
            }
        }

        @autobind
        onFileSelect(e) {
            const { files } = e.target;

            //FileLists aren't arrays. And can't do things like forEach. I'm just gonna convert it so we can use common code.
            let fileArray = [];
            for (let i = 0; i < files.length; i++) {
                fileArray.push(files[i]);
            }

            this.onFileDrop(fileArray);
        }

        @autobind
        onFileDrop(files) {
            const { ErrorDispatch, FileEdit, HasPermission, EditableChecker } = this.props;
            const { contextNode } = this.state || {};

            if(EditableChecker.CanEditContextNodeId(contextNode?.contextNodeId)) {
                this.displayProgress();

                this.setState({uploadingFiles: files}, _ => {
                    const { uploadingFiles } = this.state || {};

                    let fileProgress = [];

                    let promises = [];
                    //dataFiles.forEach(file => {
                    uploadingFiles.forEach((file, index) => {

                        fileProgress[index] = 0;

                        promises.push(
                            FileUploadService.UploadFile(
                                file.name,
                                file,
                                [contextNode.contextNodeId],
                                (a, b) => {
                                    fileProgress[index] = (a / b) * 100;
                                    this.setState({
                                        uploadProgress: fileProgress
                                    });
                                }
                            )
                        );
                    });

                    //when all the files are uploaded hide the dialog.
                    Promise.all(promises)
                        .then(ret => {
                            this.setState({uploadingFiles: false}, _ => {
                                this.hideProgress();
                                this.reloadData(ret);

                                if (ret.length === 1) {
                                    //Show edit dialog.
                                    const file = ret[0];
                                    if(file) {
                                        FileEdit?.DisplayEditOverlay?.(file);
                                    }
                                }
                            });
                        })
                        .catch(ErrorDispatch.DefaultHandler);
                });
            } else {
                //Shouldn't be able to get here.
                alert("You don't have permissions to upload a file here.");
            }
        }

        @autobind
        _getFileData(file) {
            return new Promise((resolve, reject) => {
                const reader = new FileReader();

                reader.readAsBinaryString(file);
                reader.onload = _ => resolve({name: file.name, data: reader.result});
                reader.onerror = error => reject(error);
            });
        }

        @autobind
        getDropFileMessage() {
            const { contextNode } = this.state || {};

            if(contextNode) {
                return <Fragment>
                    <h3>Drop File(s) to upload to</h3>
                    <h3>{contextNode.title}</h3>
                </Fragment>;
            }

            return <h2>Drop File(s) to upload.</h2>;
        }

        render() {
            const { displayUpload, uploadingFiles, contextNode, uploadProgress, lastChanged } = this.state;
            const { HasPermission, EditableChecker } = this.props;

            if(EditableChecker.CanEditContextNodeId(contextNode?.contextNodeId)) {
                return <Dropzone noClick noKeyboard onDrop={this.onFileDrop}>
                    {({getRootProps, getInputProps, isDragActive}) => (
                        <div {...getRootProps()}>
                            {
                                displayUpload ?
                                    <FileUploadOverlay
                                        UploadingFiles={uploadingFiles ? uploadingFiles.length: false}
                                        FileProgress={uploadProgress}
                                    />:
                                    null
                            }
                            <input
                                type="file"
                                ref={this.inputField}
                                style={{display: "none"}}
                                onChange={this.onFileSelect}
                                multiple
                            />
                            <input {...getInputProps()} />
                            {
                                isDragActive ?
                                    <Container>
                                        <div className="sb-filedrag-hover" />
                                        <div className="sb-filedrag-hover-overlay-popup">
                                            <Row>
                                                <Col xs={12}>
                                                    {this.getDropFileMessage()}
                                                </Col>
                                            </Row>
                                            <Row className="top30">
                                                <Col xs={12}>
                                                    <Glyphicon glyph="cloud-upload" />
                                                </Col>
                                            </Row>
                                        </div>
                                    </Container>:
                                    null
                            }
                            <ComposedComponent
                                ref={this.tableComponent}
                                lastChanged={lastChanged}

                                FileBrowser={{
                                    DisplayUploadDialog: this.displayDialog,
                                    DisplayUploadOverlay: this.displayProgress,
                                    HideUploadOverlay: this.hideProgress,
                                    SetContextId: this.setContextId
                                }}
                                {...this.props}
                            />
                        </div>
                    )}
                </Dropzone>;
            } else {
                return <ComposedComponent
                    ref={this.tableComponent}
                    lastChanged={lastChanged}

                    FileBrowser={{
                        DisplayUploadDialog: this.displayDialog,
                        DisplayUploadOverlay: this.displayProgress,
                        HideUploadOverlay: this.hideProgress,
                        SetContextId: this.setContextId
                    }}
                    {...this.props}
                />;
            }
        }
    }

    return FileBrowserEnhance;
});
